<template>
    <div class="cost-query">
        <div class="cost-top">
            <div class="cost-top-left">
                <el-input class="select" v-model="form.supplierCode" placeholder="供应商编码" clearable />
                <el-input class="select" placeholder="供应商名称" v-model="form.supplierNameLike" clearable></el-input>
                <MSelect
                    class="select"
                    :optionNum="'BID_EXPENSE_ORDER_TYPE'"
                    placeholder="费用类型"
                    :value="form.orderType"
                    :filterable="true"
                    @input="getOrderType"></MSelect>
                <MSelect
                    class="select"
                    :optionNum="'BID_COST_STATUS'"
                    placeholder="费用状态"
                    :value="form.costStatus"
                    :filterable="true"
                    @input="getCostStatus"></MSelect>
                <span v-has="'02010029'"><el-button class="bigData-btn-costQuery-search" type="primary" @click="searchCost" :loading="loadSearch">查询</el-button></span>
            </div>
            <div class="cost-top-right">
                <el-tooltip effect="dark" content="导出" placement="bottom" v-has="'02010030'">
                    <mExport :url="exportURl" :params="exportParams" :name="exporttName" @exportSearchChange="exportSearchChange">
                        <span class="bigData-btn-costQuery-export" slot="button-name">导出</span>
                    </mExport>
                </el-tooltip>
            </div>
        </div>
        <div class="cost-table">
            <el-table border :data="tableData" height="30" v-loading="loadSearch">
                <el-table-column type="selection" width="40" fixed></el-table-column>
                <el-table-column prop="supplierName" label="供应商" width="230"></el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="160"></el-table-column>
                <el-table-column prop="orderTypeText" label="订单项" width="150"></el-table-column>
                <el-table-column prop="supCashNo" label="押金单号" width="210" show-overflow-tooltip></el-table-column>
                <el-table-column prop="apApplyNo" label="付款申请单号" width="210" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payTypeText" label="支付方式" width="110"></el-table-column>
                <el-table-column prop="costStatusText" label="状态" width="130"></el-table-column>
                <el-table-column prop="receivePayAmount" label="应收/付金额(元)" width="130"></el-table-column>
                <el-table-column prop="actualReceivePay" label="实收/付金额(元)" width="130"></el-table-column>
                <el-table-column prop="penaltyAmount" label="罚扣款金额" width="100"></el-table-column>
                <el-table-column prop="depositContract" label="转合同押金金额" width="130"></el-table-column>
                <el-table-column prop="bankAccount" label="银行卡号" width="170"></el-table-column>
                <el-table-column prop="bankAccountName" label="银行名称" width="150"></el-table-column>
                <el-table-column prop="contactName" label="联系人" width="70"></el-table-column>
                <el-table-column prop="contactNumber" label="联系电话" width="110"></el-table-column>
                <el-table-column prop="costRejectionCause" label="驳回原因" width="150"></el-table-column>
                <el-table-column prop="orderTime" label="制单时间" width="170"></el-table-column>
                <el-table-column prop="transactionTime" label="收付款时间" width="170"></el-table-column>
                <el-table-column prop="auditUserName" label="审核人" width="80"></el-table-column>
                <el-table-column prop="auditTime" label="审核时间" width="170"></el-table-column>
                <el-table-column prop="deductionPerson" label="罚扣款操作人" width="120"></el-table-column>
                <el-table-column prop="deductionUpdate" label="罚扣款操作时间" width="170"></el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="170">
                    <template slot-scope="scope">
                        <span>
                            <el-button class="btn-text"
                                v-if="scope.row.orderType !== '3' && scope.row.costStatus === '1'"
                                type="text"
                                @click="freeReFunc(scope.row)">支付刷新</el-button>
                        </span>
                        <span v-has="'02010031'">
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if=" scope.row.costStatus === '2' || scope.row.costStatus === '3'"
                                @click="handleExamine(scope.$index, scope.row)"
                                type="text">{{ scope.row.costStatus === "2" ? "审核" : "查看" }}</el-button>
                        </span>
                        <span v-has="'02010032'">
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if="scope.row.orderType === '2' && scope.row.costStatus === '5' && scope.row.refund !== '1'"
                                @click="handleFine(scope.$index, scope.row)"
                                type="text">罚扣款</el-button>
                        </span>
                        <span v-has="'02010033'">
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if="scope.row.costStatus === '2'"
                                @click="handleReject(scope.$index, scope.row)"
                                type="text">驳回</el-button>
                        </span>
                        <span>
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if="scope.row.costStatus === '5'"
                                @click="fileClick(scope.row)"
                                type="text">收据</el-button>
                        </span>
                        <span v-has="'02010076'">
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if="scope.row.orderType === '3' && scope.row.costStatus === '1'"
                                @click="uploadFileFunc(scope.row)"
                                type="text">退款申请函上传</el-button>
                        </span>
                        <span>
                            <el-button
                                size="mini"
                                class="btn-text"
                                v-if=" scope.row.orderType === '3' && (scope.row.costStatus === '3' || scope.row.costStatus === '6')"
                                @click="fileClick(scope.row)"
                                type="text">退款申请函</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
        <el-dialog
            title="罚扣款"
            :visible.sync="fineDetail"
            width="520px"
            :close-on-click-modal="false"
            :before-close="fineClose">
            <el-form
                ref="fineForm"
                :rules="fineRules"
                :model="fineForm"
                label-width="125px">
                <el-form-item label="罚扣款金额(元)" prop="penaltyAmount">
                    <el-input-number
                        class="item-input"
                        v-model="fineForm.penaltyAmount"
                        controls-position="right"
                        :precision="2"
                        :step="1"
                        :min="0"
                        :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item label="罚扣款原因" prop="penaltyCause">
                    <el-input class="item-input" type="textarea" v-model="fineForm.penaltyCause" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="fineClose">取 消</el-button>
                <el-button type="primary" @click="fineDetermine">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="投标保证金驳回" :visible.sync="rejectDetail" width="500px" :close-on-click-modal="false" :before-close="rejectClose">
            <el-form ref="rejectForm" :rules="rejectRules" :model="rejectForm" label-width="125px">
                <el-form-item label="联系人" prop="contactName">
                    <el-input class="item-input" v-model="rejectForm.contactName" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="contactNumber">
                    <el-input class="item-input" v-model="rejectForm.contactNumber" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="驳回原因" prop="costRejectionCause">
                    <el-input class="item-input" type="textarea" v-model="rejectForm.costRejectionCause" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rejectClose">取 消</el-button>
                <el-button type="primary" @click="rejectDetermine">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="文件信息"
            :visible.sync="fileSeal"
            width="970px"
            close-on-click-modal>
            <el-table :data="fileData" height="300" style="width: 100%">
                <el-table-column prop="fileName" label="名称" width="250" :show-overflow-tooltip="true" align="center"></el-table-column>
                <el-table-column prop="moduleNo" label="编号" width="280" align="center"></el-table-column>
                <el-table-column prop="fileId" label="文件ID" width="100" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
                <el-table-column prop="action" label="操作" align="center" width="100">
                    <template slot-scope="scope" class="action">
                        <span class="btn-del">
                            <el-button size="mini" @click="preview(scope.row)" type="text">预览</el-button></span>
                        <span v-has="'02010073'" class="btn-del"><el-button size="mini" @click="download(scope.row)" type="text">下载</el-button></span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="dialogFile-footer"><el-button class="fileClose" @click="fileClose">关 闭</el-button></div>
        </el-dialog>
        <uploadFile
            :MDialogshow="isShowUploadFile"
            :uploadFile="'退款申请函上传'"
            :rowBidDialogData="rowBidDialogData"
            @mdialogFn="mdialogFn"></uploadFile>
        <examine-dialog
            v-if="showExamine"
            :showExamine.sync="showExamine"
            :id="id"
            :orderType="orderType"
            :costStatus="costStatus"
            :supplierName="supplierName"
            @updateData="updateData"></examine-dialog>
    </div>
</template>
<script>
import MSelect from '@/components/lots/otpSelect2';
import mExport from '@/components/awesome/page/fileHandle/export';
import { mapGetters } from 'vuex';
import {
    costList,
    fineMoneyReq,
    reject,
    refund,
    PayByOrderNo
} from '../../../api/supplierBid.js';
import { moduleFile } from '../../../api/annoMana.js';
import { dictWithUrl } from '@/components/lots/api';
import examineDialog from './examineDialog.vue';
import { filePreview } from '@/utils/filePreview.js';
import uploadFile from './uploadFile.vue';
export default {
    components: { MSelect, mExport, examineDialog, uploadFile },
    data() {
        return {
            isShowUploadFile: false,
            rowBidDialogData: {},
            loadSearch: false,
            dictData: {}, // 数字字典
            depositContract: '', // 合同押金
            actualReceivePay: '', // 实收金额
            showExamine: false,
            fileData: [],
            fileSeal: false,
            id: '',
            orderType: '',
            costStatus: '',
            form: {
                supplierCode: this.$route.query.supplierCode || '',
                supplierNameLike: '',
                costType: '',
                orderType: '',
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            tableData: [],
            refundList: [],
            fineForm: {
                penaltyAmount: '',
                penaltyCause: '',
                id: ''
            },
            fineDetail: false,
            fineRules: {
                penaltyAmount: [
                    {
                        required: true,
                        message: '请输入罚扣款金额',
                        trigger: 'blur'
                    },
                    { type: 'number', message: '请输入数字' }
                ],
                penaltyCause: [
                    {
                        required: true,
                        message: '请输入罚扣款原因',
                        trigger: 'blur'
                    }
                ]
            },
            rejectForm: {
                contactName: '',
                contactNumber: '',
                costRejectionCause: '',
                id: ''
            },
            rejectDetail: false,
            rejectRules: {
                contactName: [
                    {
                        required: true,
                        message: '请输入联系人',
                        trigger: 'blur'
                    }
                ],
                contactNumber: [
                    {
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur'
                    }
                ],
                costRejectionCause: [
                    {
                        required: true,
                        message: '请输入驳回原因',
                        trigger: 'blur'
                    }
                ]
            },
            exportURl: '/api-srm-web/bid/export/bidSupplierCost',
            exporttName: '费用查询文件.xlsx',
            iflowId: this.$route.query.mbpmFlowId,
            exportParams: {},
            supplierName: '', // 费用查询-当前操作行-供应商名称
            isRefundApply: false, // 是否点击的是 退款申请函 按钮
        };
    },
    mounted() {
        dictWithUrl('BID_EXPENSE_ORDER_TYPE,BID_COST_STATUS,BID_PAY_TYPE').then(
            (res) => {
                this.dictData = res.data;
                this.init();
            }
        );
    },
    methods: {
        mdialogFn() {
            this.isShowUploadFile = false;
            this.init();
        },
        uploadFileFunc(row) {
            this.isShowUploadFile = true;
            this.rowBidDialogData = row;
        },
        freeReFunc(row) {
            const par = { orderNo: row.orderNo };
            PayByOrderNo(par).then((res) => {
                this.init();
            });
        },
        // 审核
        handleExamine($index, row) {
            this.showExamine = true;
            this.id = row.id;
            this.orderType = row.orderType;
            this.costStatus = row.costStatus;
            this.supplierName = row.supplierName
        },
        // 审核确认后的回调
        updateData() {
            this.init();
        },
        // 查询
        searchCost() {
            this.loadSearch = true;
            this.form.pageNo = 1;
            this.init();
        },
        // 罚扣款按钮
        handleFine($index, row) {
            this.depositContract = row.depositContract; // 合同押金
            this.actualReceivePay = row.actualReceivePay; // 实收金额
            this.fineDetail = true;
            this.fineForm.id = row.id;
            this.fineForm.penaltyAmount = row.penaltyAmount;
            this.fineForm.penaltyCause = row.penaltyCause;
        },
        // 罚扣款弹窗确定按钮
        fineDetermine() {
            // 实收金额>合同押金+罚扣款
            const fineMoney = (rule, value, callback) => {
                // console.log('fineMoney', value)
                if (!value) {
                    callback(new Error('请输入扣款金额'));
                } else if (
                    this.actualReceivePay * 1 <
                    this.depositContract * 1 + value * 1
                ) {
                    callback(new Error('扣款金额不能大于缴纳金额'));
                } else {
                    callback();
                }
            };
            this.fineRules.penaltyAmount = [
                { validator: fineMoney, trigger: 'blur' }
            ];
            this.$refs['fineForm'].validate(async (valid) => {
                if (valid) {
                    const res = await fineMoneyReq(this.fineForm);
                    if (res && res.code === '0') {
                        this.fineForm.id = '';
                        this.fineForm.penaltyAmount = '';
                        this.fineForm.penaltyCause = '';
                        this.fineDetail = false;
                        this.init();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                }
            });
        },
        // 罚扣款弹窗取消按钮
        fineClose() {
            this.$refs['fineForm'].resetFields();
            this.fineForm.id = '';
            this.fineForm.penaltyAmount = '';
            this.fineForm.penaltyCause = '';
            this.fineDetail = false;
        },
        // 驳回按钮
        handleReject($index, row) {
            this.rejectDetail = true;
            this.rejectForm.id = row.id;
        },
        // 驳回弹窗确认按钮
        rejectDetermine() {
            this.$refs['rejectForm'].validate(async (valid) => {
                if (valid) {
                    const res = await reject(this.rejectForm);
                    if (res && res.code === '0') {
                        this.rejectForm.contactName = '';
                        this.rejectForm.contactNumber = '';
                        this.rejectForm.costRejectionCause = '';
                        this.rejectForm.id = '';
                        this.init();
                        this.rejectDetail = false;
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                }
            });
        },
        // 驳回弹窗取消按钮
        rejectClose() {
            this.$refs['rejectForm'].resetFields();
            this.rejectDetail = false;
            this.rejectForm.contactName = '';
            this.rejectForm.contactNumber = '';
            this.rejectForm.costRejectionCause = '';
            this.rejectForm.id = '';
        },
        async fileClick(row) {
            this.fileSeal = true;
            this.fileData = [];
            let par = {};
            // 订单项为投标保证金退款，状态为审核中、已退款
            if (
                row.orderType === '3' &&
                (row.costStatus === '3' || row.costStatus === '6')
            ) {
                par = {
                    moduleNo: row.orderNo,
                    stampStatus: 'Y',
                    fileAttribute: '18'
                };
                this.isRefundApply = true
            } else {
                par = { moduleNo: row.orderNo, stampStatus: 'Y' };
                this.isRefundApply = false
            }
            const res = await moduleFile(par);
            if (res.data) {
                this.fileData = res.data.list;
            }
            this.supplierName = row.supplierName
        },
        fileClose() {
            this.fileSeal = false;
            this.supplierName = ''
        },
        preview(row) {
            filePreview(row);
        },
        download(row) {
            // 点击退款申请函的下载走这里
            if (this.isRefundApply) {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', row.fileUrl, true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        const filename = '退款申请函' + (this.supplierName ? ('-' + this.supplierName) : '') + '.' + row.fileType
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(xhr.response, filename);
                        } else {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(xhr.response);
                            link.download = filename;
                            link.click();
                            window.URL.revokeObjectURL(link.href);
                        }
                    }
                };
                xhr.send();
            } else {
                window.open(row.fileUrl, '_parent');
            }
        },
        handleSizeChange(val) {
            this.form.pageNo = 1;
            this.form.pageSize = val;
            this.init();
        },
        handleCurrentChange(val) {
            this.form.pageNo = val;
            this.init();
        },
        async init() {
            const refundRes = await refund({ bidNo: this.$route.query.bidNo }).catch(err => {});
            if (refundRes && refundRes.data.length !== 0) {
                this.refundList = refundRes.data || [];
            }
            const res = await costList({
                bidNo: this.$route.query.bidNo,
                iflowId: this.iflowId,
                ...this.form
            }).catch(err => {});
            this.loadSearch = false;
            if (res && res.code === '0') {
                this.tableData = res.data.list;
                this.conversionData(this.tableData);
                this.totalCount = res.data.totalCount;
            }
            this.exportParams = {
                bidNo: this.$route.query.bidNo,
                tenantCode: this.currentTenant.tenantCode,
                ...this.form
            }
            delete this.exportParams.pageNo
            delete this.exportParams.pageSize
            this.tableData.forEach((item) => {
                this.refundList.forEach((item2) => {
                    if (item.supplierCode === item2.supplierCode) {
                        item.refund = '1'; // 代表有退款的
                    }
                });
            });
        },
        conversionData(list) {
            list.map((item) => {
                item.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[item.orderType];
                item.costStatusText = this.dictData.BID_COST_STATUS[item.costStatus];
                item.payTypeText = this.dictData.BID_PAY_TYPE[item.payType];
            });
            return list;
        },
        getOrderType(val) {
            this.form.orderType = val;
        },
        getCostStatus(val) {
            this.form.costStatus = val;
        },
        exportSearchChange() {}
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode'])
    }
};
</script>
<style lang="less">
.cost-query {
    display: flex;
    flex-direction: column;

    .cost-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        .cost-top-left {
            display: flex;
        }

        .select {
            margin-right: 10px;
            width: 160px;
        }

        .cost-top-right {
            display: flex;
            justify-content: center;
            align-items: center;

            .demo-export {
                margin-top: 2px;
                margin-right: 5px;
            }

            .el-button--mini {
                padding: 6.4px 10px;
                font-size: 12px;
                color: #fff;
                background-color: #00bcbf;
                border: none;
            }
        }

        .el-icon-upload2 {
            font-size: 15px;
            color: #fff;
        }

        .load-info {
            font-size: 14px;
        }
    }

    .cost-table {
        .el-table {
            min-height: calc(~"100vh - 350px");
            max-height: calc(~"100vh - 350px");
        }

        .el-table__body-wrapper {
            min-height: calc(~"100vh - 386px");
            max-height: calc(~"100vh - 386px");
        }

        .el-table--border {
            border: 1px solid #ebeef5;
        }
    }

    .item-input {
        width: 300px;
    }

    .btn-text {
        margin-right: 10px;
    }

    .dialogFile-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;
    }

    .btn-del {
        margin-left: 10px;
    }
}
</style>